import { put, takeLatest, select, call, all } from 'redux-saga/effects';
import { GET_QUESTION_FAILURE, GET_QUESTION_SUCCESS, GET_QUESTION_REQUEST } from '../actions/question.action';
import { getQuestions } from './question.api';
import { IRootState } from '../reducer';
import { CategoryType, IQuestion, QuestionGroupOptions } from '../reducer/question.types';
import { prefetchQuestionsMediaSources } from '../utils/prefetchMediaSources';
import { getUsersMarkedQuestions } from '../selectors/user.selectors';
import { getMarkedCategory, getQuestionById } from '../utils/utils';

const getCategory = ({ user }: IRootState) => user.profile.currentCategory;
const getSelectedQuestionGroup = ({ user }: IRootState) => user.profile.selectedQuestionGroup;
const getUserAnswersCash = ({ answer: { answerListCash } }: IRootState) => answerListCash;

function* getQuestionList(action) {
  try {
    const currentCategory: CategoryType = yield select(getCategory);
    const markedCategory = getMarkedCategory(currentCategory);
    const markedQuestions = yield select(getUsersMarkedQuestions);
    const userAnswersCash = yield select(getUserAnswersCash);
    const selectedQuestionGroup = yield select(getSelectedQuestionGroup);
    let questionsFromTopic: number[] = [];
    if (action.payload.topic === 'marked') {
      if (selectedQuestionGroup === QuestionGroupOptions.ASA && markedQuestions[markedCategory]) {
        markedQuestions[markedCategory].forEach(answerKey => {
          const question = getQuestionById(+answerKey);
          if (question?.asa) {
            questionsFromTopic.push(+answerKey);
          }
        });
      } else {
        questionsFromTopic = [...markedQuestions[markedCategory]];
      }
    }

    if (action.payload.topic === 'incorrect') {
      const topicIds = Object.keys(userAnswersCash);
      topicIds.forEach(topicId => {
        const answersKeyList = Object.keys(userAnswersCash[topicId]);
        answersKeyList.forEach(answerKey => {
          if (
            typeof userAnswersCash[topicId][answerKey].correct === 'boolean' &&
            !userAnswersCash[topicId][answerKey].correct
          ) {
            if (selectedQuestionGroup === QuestionGroupOptions.ASA) {
              if (userAnswersCash[topicId][answerKey]?.questionType === QuestionGroupOptions.ASA) {
                questionsFromTopic.push(Number(answerKey));
              }
            } else {
              questionsFromTopic.push(Number(answerKey));
            }
          }
        });
      });
    }

    const data = yield call(
      getQuestions,
      action.payload.topic,
      currentCategory,
      questionsFromTopic,
      selectedQuestionGroup
    );
    yield put(GET_QUESTION_SUCCESS(data));
  } catch (e) {
    yield put(GET_QUESTION_FAILURE(e.message));
  }
}

function prefetchQuestionMedia({ payload }: { payload: IQuestion[] }) {
  prefetchQuestionsMediaSources(payload);
}

function* questionSaga() {
  yield all([
    takeLatest(GET_QUESTION_REQUEST, getQuestionList),
    takeLatest(GET_QUESTION_SUCCESS, prefetchQuestionMedia)
  ]);
}

export default questionSaga;
